import ResetPassword from './ResetPasswordContainer'

export default ResetPassword



// WEBPACK FOOTER //
// ./src/components/ResetPassword/index.js